module.exports = __webpack_public_path__ + "static/media/Rapid_Securing_Device_01.01144478.jpg";